import React, { useId } from 'react';

import CommonCheckbox from '../../common-checkbox/CommonCheckbox';

import scss from './FilterSection.module.scss';

function FilterItem({ option, isChecked, onSelect }) {
  const { label } = option;

  const id = useId();

  const handleSelect = () => {
    onSelect(option);
  };

  return (
    <label className={scss.option} htmlFor={id}>
      <CommonCheckbox checked={isChecked} onChange={handleSelect} id={id} />
      <span className={scss.optionLabel}>{label}</span>
    </label>
  );
}

export default FilterItem;
